import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import Modal from 'react-modal';

import $ from 'jquery';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
import * as MESSAGES from '../Lib/Messages';
import {
	QueryAnalysisList,
	MutationDeleteAnalysis
} from "../GraphQL/MutationAnalysis";

import BreadCrumb from './BreadCrumb';
import Spinner from './Spinner';
import Notification from './Notification';
import ModalContent from './ModalContent';

// import moment from "moment";
import moment from "moment-timezone";

class AnalysisList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			delObj: {
				therapistId: null,
				analysisId: null
			},
			modalIsOpen: false,
			errors: {},
			isError: false,
			errorMessage: null,
			patientData: {
				firstName: '',
				lastName: ''
			},
			handSideObj: {
				'LT': 'Left Dorsal',
				'LB': 'Left Palmar',
				'RT': 'Right Dorsal',
				'RB': 'Right Palmar',
			}
		};

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(event) {

	}

	confirmDelete(obj) {
		this.setState({ delObj: obj });
		this.openModal();
	}

	openModal = () => {
		this.setState({modalIsOpen: true});
	}

	afterOpenModal = () => {
		// console.log('afterOpenModal');
	}

	closeModal = () => {
		this.setState({modalIsOpen: false});
	}

	handleDeleteItem = async (e) => {
        console.log("Deleting an item");
        this.setState({ loading: true });
        this.closeModal();
		if(!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true, loading: false });
			return false;
		}

        let { delObj } = this.state;
        const { deleteAnalysis } = this.props;

		try {
			const obj = await deleteAnalysis(delObj);
			if(!obj.data.errors) {
				this.setState({ errorMessage: MESSAGES.SUCCESS_DELETE_ANALYSIS, isError: false });
			} else {
				this.setState({ errorMessage: MESSAGES.ERROR_DELETE_ANALYSIS, isError: true });
			}
		} catch(e) {
			this.setState({ errorMessage: MESSAGES.ERROR_DELETE_ANALYSIS, isError: true });
		}

        this.setState({ loading: false });
    }

	componentDidMount() {
		if(!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
		}
	}

	componentWillReceiveProps(newProps) {
		const { patientData } = newProps;
		if(patientData) {
			this.setState({ patientData });
		}
		if(newProps.analysisList.length > 0) {
			$('.dataTables_empty').parent().remove();
		}
		setTimeout(function() {
            if(!newProps.listLoading && $('#datatable-tabletools_filter').length === 0) {
				window.pdfMake.vfs = pdfFonts.pdfMake.vfs;
                window.datatableInit();
            }
        }, 500);
	}

	componentWillMount() {
        Modal.setAppElement('body');
    }

	render() {
		const { patientData } = this.state;
		const { match: { params: {assessment_id } }, analysisList } = this.props;
		return (
			<section role="main" className="content-body">
				<Modal
					 isOpen={this.state.modalIsOpen}
					 onAfterOpen={this.afterOpenModal}
					 onRequestClose={this.closeModal}
					 className="mfp-content"
					 overlayClassName="mfp-bg"
				 >
					 <ModalContent
						 onHide={this.closeModal}
						 handleModal={this.handleDeleteItem.bind(this)}
						 title="Are you sure for delete this analysis?"
						 message="Please confirm. This action cannot be undone."
					 />
				</Modal>

				<header className="page-header">
					<h2>Assessments - {patientData.firstName} {patientData.lastName}</h2>
					<BreadCrumb title1="Assessments" title2="List" />
				</header>

				<Notification isError={this.state.isError} message={this.state.errorMessage} />

				<div className="row">
					<div className="col">
						<section className="card">
							<div className={`card-body${this.props.loading ? ' loading-overlay-showing' : ''}`}>
		                        <Spinner />
								<Link className="btn btn-primary btn-ass-create" to={`/assessments/create/${assessment_id}`}>
									Create <i className="fa fa-plus"></i>
								</Link>
								<table className="table table-bordered table-striped mb-0" id="datatable-tabletools">
		                            <thead>
		                                <tr>
		                                    <th>#</th>
											<th>Hand Side</th>
											<th>Type</th>
		                                    <th>Date</th>
		                                    <th>Note Title</th>
		                                    <th>Action</th>
		                                </tr>
		                            </thead>
		                            <tbody>
										{[].concat(analysisList).sort((a, b) => b.created.localeCompare(a.created)).map((item, i) => (
		                                  	<tr key={i}>
												<td className="center">{i+1}</td>
												<td>{this.state.handSideObj[item.handSide]}</td>
												<td>{item.type === 'WEST' ? 'WEST' : 'SWMT'}</td>
												<td>{moment(item.date).utcOffset(item.date).format('DD MMMM YYYY HH:mm')}</td>
												<td>
												{(() => {
													switch (item.handSide) {
														case "LT": return item.noteTitleLT;
														case "LB": return item.noteTitleLB;
														case "RT": return item.noteTitleRT;
														default: return item.noteTitleRB;
													}
												})()}
												</td>
												<td className="center actions">
													<Link to={'/assessments/view/' + item.assessmentId + '/' + item.analysisId} className="on-default" title="View Assessment">
														<i className="fas fa-info fa-lg"></i>
													</Link>&nbsp;
													<Link to={'/assessments/' + item.assessmentId + '/' + item.analysisId} className="on-default" title="Edit Assessment">
														<i className="fas fa-pencil-alt fa-lg"></i>
													</Link>&nbsp;
													<a href="javascript:void(0)" className="on-default" title="Remove Assessment"
														onClick={ () => this.confirmDelete( {assessmentId: item.assessmentId, analysisId: item.analysisId} ) }>
														<i className="fas fa-trash-alt fa-lg"></i>
													</a>
												</td>
		                                  	</tr>
		                              	))}
		                            </tbody>
		                        </table>
							</div>
						</section>
					</div>
				</div>
			</section>
		)
	}
}

export default compose(
	graphql(QueryAnalysisList, {
		options: (props) => ({
			fetchPolicy: 'network-only',
			variables: {
				therapistId: localStorage.getItem('subHandsApps'),
		        assessmentId: props.match.params.assessment_id
			}
		}),
		props:  ({ data: {loading, getAssessment = { analysis: { items: [] } } } }) => ({
			analysisList: (getAssessment) ? getAssessment.analysis.items : [],
			patientData: getAssessment,
            loading,
			listLoading: loading
		})
 	}),
	graphql(MutationDeleteAnalysis, {
		options: (props) => ({
			refetchQueries: [{
				query: QueryAnalysisList,
				variables: {
					therapistId: localStorage.getItem('subHandsApps'),
			        assessmentId: props.match.params.assessment_id
				}
			}],
		}),
		props: (props) => ({
			deleteAnalysis: (analysis) => {
				return props.mutate({
					variables: analysis,
					optimisticResponse: () => ({
						deleteAnalysis: {
							...analysis, __typename: 'Analysis'
						}
					}),
				})
			},
		})
	}),
)(AnalysisList);
